<template>
  <router-view />
</template>

<script setup>
import { onMounted } from 'vue';
import { useBrazeStore } from './stores/brazeStore';

const brazeStore = useBrazeStore();

onMounted(async () => {
  await brazeStore.initializeStore();
});
</script>
